<template>
  <div v-if="isBottom" class="footer-box" ref="footerContent" :style="{'height': height + 'px'}">
    <div class="btn-footer" :style="style">
        <div class="footer-left">
          <slot name="footerLeft"/>
        </div>
        <div class="inner">
          <slot/>
        </div>
    </div>
  </div>
  <div v-else class="footer-box-bottom">
    <div class="btn-footer-bottom">
        <div class="footer-left">
          <slot name="footerLeft"/>
        </div>
        <div class="inner">
          <slot/>
        </div>
    </div>
  </div>
</template>

<script>
  import { TAB_PAGE_FRAME_STORAGE_KEY } from '../../business/layout-tab/constans'
  import { footerProps } from './index.js'
  import resizeObserverMixin from './resize-observer'
  export default {
    name: 'footer',
    props: footerProps,
    mixins: [resizeObserverMixin],
    data () {
      return {
        height: 56,
        resizeObserver: null,
        style: {
          width: 'auto',
          maxWidth: '1200px',
          left: null
        },
        observer: null,
        isBottom: true,
        isTab: localStorage.getItem(TAB_PAGE_FRAME_STORAGE_KEY) === '1'
      }
    },
    created () {
      if (window.fe.project === 'mall') this.isBottom = false
    },
    mounted () {
      if (this.isBottom) {
        // 这个吸底位置计算还有问题  后续用的话   还需要优化
        let element = document.querySelector('.footer-box')
        let height = document.querySelector('.btn-footer').getBoundingClientRect().height
        window.fe.fixedBottom = [{
          height,
          key: 'bottomFixed'
        }]
        this.height = height
        if (this.isTab) {
          this.createdResizeObserver((entry) => {
            const ClientRect = element.getBoundingClientRect()
            if (this.style.left !== ClientRect.left) {
              this.style.left = ClientRect.left + 'px'
              this.style.width = ClientRect.width ? ClientRect.width + 'px' : 'auto'
              this.style.maxWidth = 'none'
            }
          }, element)
        } else {
          this.style.left = element.getBoundingClientRect().left + 'px'
          window.onresize = () => {
            this.style.left = element.getBoundingClientRect().left + 'px'
          }
        }
      } else {
        // 第二种也需要高度
        let height = document.querySelector('.btn-footer-bottom')?.getBoundingClientRect().height
        window.fe.fixedBottom = [{
          height,
          key: 'bottomFixed'
        }]
      }
    },
    methods: {
      initWidth (left) {
        this.style = {
          'left': `${left}px`,
          'display': 'block'
        }
      }
    }
  } 
</script>

<style lang="scss" scoped>
  // @import '@/common/css/variable.scss';
  $default-color: #fff;
  $font-color: #333;
  .footer-box {
    min-height: 56px;
    // margin-left: -16px;
  }
  .footer-box-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1210; 
  }
  .btn-footer {
    // display: none;
    position: fixed;
    bottom: 0;
    right: 0;
    min-height: 56px;
    background-color: #fff;
    padding: 9px 24px 9px 16px;
    box-sizing: border-box;
    box-shadow: 0px 0 8px rgba(57, 121, 201, 0.14);
    border: 1px solid #d6dfff;
    z-index: 1210;
    .inner {
      float: right;
      line-height: 36px;
    }
  }
  .btn-footer-bottom {
    // display: none;
    min-height: 56px;
    background-color: #fff;
    padding: 9px 24px 9px 16px;
    box-sizing: border-box;
    box-shadow: 0px 0 8px rgba(57, 121, 201, 0.14);
    border: 1px solid #d6dfff;
    z-index: 1210;
    .inner {
      float: right;
      line-height: 36px;
    }
  }
  .footer-box ::v-deep {
    .sy-button-gallery__horizontal-wrap {
        margin-bottom: 0 !important;
    }
    .button-wrap {
        margin-bottom: 0 !important;
    }
  }
</style>
